// filepath: src/admin/CalendarPage.js
import React from "react";
import Calendar from "../components/CommonComponents/Calendar";

export default function AdminCalendarPage() {
    return (
        <Calendar />
    );
}
